<div class="form-row animated fadeInDown d-flex justify-content-center">
    <div class="col-md-6">
        <div class="box box-primary">
            <div class="box-header text-center">
                <h4 class="text-primary">Alterar Senha</h4>
            </div><!-- box-header -->

            <div class="box-body">
                <form novalidate [formGroup]="form">
                    <div class="form-row">
                        <div class="col-md-6">
                            <div class="position-relative form-group">
                                <label for="senhaNova">Nova Senha</label>
                                <input class="form-control" formControlName="senhaNova" type="password" required>
                            </div>
                        </div>
                    </div><!-- nome -->
                </form>

            </div><!-- box-body -->

            <div class="box-footer">
                <div class="d-flex justify-content-end">
                    <button type="submit" class="btn btn-lg btn-shadow btn-primary pl-5 pr-5" (click)="submit()">
                        Alterar
                    </button>
                </div>
            </div><!-- box-footer -->
        </div><!-- box -->
    </div><!-- col- -->
</div><!-- row -->